(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-faq-template"]) return;
  try {
    
(function() {
  $('body').on('click', '.shopify_explorer_faq__question', function() {
    $(this).next('.shopify_explorer_faq__answer').slideToggle(150).toggleClass('active');
    $(this).toggleClass('active');
  });
  $(document).on('shopify:block:select', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
    $(event.target).find('.shopify_explorer_faq__answer').slideDown(150);
  });
  $(document).on('shopify:block:deselect', '#shopify-section-page-shopify_explorer_faq-template', function(event) {
    $(event.target).find('.shopify_explorer_faq__answer').slideUp(150);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-pairs-well"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    var $slider = $('.product-slider .slider');
    var $bar = $('.slider-scrollbar');
    var $handle = $bar.find('.handle');

    // bind events
    $slider.on('init setPosition breakpoint', function(e, slick){
      var s = slick || $slider.slick('getSlick');
      updateHandle(s);
      syncHandle(s);
    });

    $slider.on('afterChange', function(e, slick){
      var s = slick || $slider.slick('getSlick');
      syncHandle(s);
    });

    // init slick
    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 576,  settings: { slidesToShow: 2 } }
      ]
    });

    // resize debounce
    var rTimer;
    $(window).on('resize', function(){
      clearTimeout(rTimer);
      rTimer = setTimeout(function(){
        var s = $slider.slick('getSlick');
        updateHandle(s);
        syncHandle(s);
      }, 80);
    });

    // -------------------------
    // Update / Sync handle
    // -------------------------
    function updateHandle(slick){
      if(!slick) return;

      var total = slick.slideCount || 0;
      var show  = slick.options && slick.options.slidesToShow ? slick.options.slidesToShow : 1;
      var barW  = $bar.innerWidth();
      var hidden = Math.max(0, total - show);

      if(hidden <= 0 || barW <= 0){
        $bar.addClass('disabled');
        $handle.css({ width: barW, left: 0 });
        return;
      }

      var handleW;

      if(window.innerWidth < 768){
        // mobile formula
        handleW = (show / total) * barW;
      } else {
        // desktop formula
        var trackW = 0;
        try { trackW = slick.$slideTrack && slick.$slideTrack[0] ? slick.$slideTrack[0].scrollWidth : 0; } catch(err){ trackW = 0; }
        if(!trackW || trackW <= 0){
          handleW = (show / total) * barW;
        } else {
          handleW = (trackW - barW) / hidden;
        }
      }

      var minHandle = Math.max(24, Math.round(barW * 0.04));
      if(!isFinite(handleW) || handleW <= 0) handleW = minHandle;
      handleW = Math.max(minHandle, Math.round(handleW));

      $bar.removeClass('disabled');
      $handle.css('width', handleW + 'px');
    }

    function syncHandle(slick){
      if(!slick) return;

      var total = slick.slideCount || 0;
      var show  = slick.options && slick.options.slidesToShow ? slick.options.slidesToShow : 1;
      var barW  = $bar.innerWidth();
      var handleW = $handle.outerWidth();
      var hidden = Math.max(0, total - show);

      if(hidden <= 0 || barW <= 0){
        $handle.css('left', 0);
        return;
      }

      var maxLeft = barW - handleW;
      var cur = Math.max(0, Math.min(slick.currentSlide || 0, hidden));
      var left = (cur / hidden) * maxLeft;
      $handle.css('left', left + 'px');
    }

    // -------------------------
    // Drag: threshold incremental
    // -------------------------
    var dragging = false;
    var startX = 0;
    var startLeft = 0;
    var lastSlideOnDrag = 0;

    var sensitivity = 0.5;   
    var minStepPx = 12;      

    function dragStart(clientX){
      if($bar.hasClass('disabled')) return;
      var slick = $slider.slick('getSlick');
      if(!slick) return;

      dragging = true;
      startX = clientX;
      startLeft = parseFloat($handle.css('left')) || 0;

      var total = slick.slideCount || 0;
      var show = slick.options && slick.options.slidesToShow ? slick.options.slidesToShow : 1;
      var hidden = Math.max(0, total - show);
      lastSlideOnDrag = Math.max(0, Math.min(slick.currentSlide || 0, hidden));
    }

    function dragMove(clientX){
      if(!dragging) return;
      var slick = $slider.slick('getSlick');
      if(!slick) return;

      var total = slick.slideCount || 0;
      var show  = slick.options && slick.options.slidesToShow ? slick.options.slidesToShow : 1;
      var barW  = $bar.innerWidth();
      var handleW = $handle.outerWidth();
      var hidden = Math.max(0, total - show);

      if(hidden <= 0 || barW <= 0) return;

      var maxLeft = barW - handleW;
      var stepPx = (maxLeft / Math.max(1, hidden));
      var effectiveStep = Math.max(minStepPx, stepPx * sensitivity);

      var deltaX = clientX - startX;
      var nextLeftVisual = Math.min(maxLeft, Math.max(0, startLeft + deltaX));
      $handle.css('left', nextLeftVisual + 'px');

      var steps = Math.trunc(deltaX / effectiveStep);
      if(steps !== 0){
        var target = lastSlideOnDrag + steps;
        target = Math.max(0, Math.min(target, hidden));
        if(target !== lastSlideOnDrag){
          $slider.slick('slickGoTo', target, false);
          lastSlideOnDrag = target;
          startX += steps * effectiveStep;

          // adjust visual handle to precise snapped position corresponding to target
          var snappedLeft = (target / hidden) * maxLeft;
          $handle.css('left', snappedLeft + 'px');
          // also update startLeft so further free dragging calculated consistently
          startLeft = snappedLeft;
        }
      }
    }

    function dragEnd(){
      dragging = false;
    }

    // pointer events (desktop)
    $handle.on('pointerdown', function(e){
      dragStart(e.clientX);
      try { this.setPointerCapture && this.setPointerCapture(e.pointerId); } catch(err){}
      e.preventDefault();
    });
    // use document-level move so dragging still works if cursor/finger leaves handle
    $(document).on('pointermove', function(e){
      if(dragging) dragMove(e.clientX);
    });
    $(document).on('pointerup pointercancel', function(){ dragEnd(); });

    // touch events (mobile)
    $handle.on('touchstart', function(e){
      if(e.originalEvent && e.originalEvent.touches && e.originalEvent.touches.length){
        dragStart(e.originalEvent.touches[0].clientX);
      }
    });
    // need passive:false to prevent page scroll during drag — jQuery doesn't allow options, so use native listener
    document.addEventListener('touchmove', function(e){
      if(!dragging) return;
      if(e.touches && e.touches.length){
        // prevent scrolling while dragging
        e.preventDefault();
        dragMove(e.touches[0].clientX);
      }
    }, { passive: false });
    $(document).on('touchend touchcancel', function(){ dragEnd(); });

    // run first-time sync if slick already exists
    var s0 = $slider.slick('getSlick');
    if(s0) {
      updateHandle(s0);
      syncHandle(s0);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
